import { render } from "./InjuryReport.vue?vue&type=template&id=736dec70"
import script from "./InjuryReport.vue?vue&type=script&lang=js"
export * from "./InjuryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__